import { AfterViewInit, Component, OnInit } from '@angular/core';
import { builtInButtons, defaultStepOptions } from '../../tour/data';
import { ShepherdService } from 'angular-shepherd';
import { SenderService } from '../../services/sender.service';
import { InterfaceService } from '../../services/interface.service';
import { filter, first } from 'rxjs/operators';
import { NotifierWrapService } from '../../services/notifier-wrap.service';
import Step from 'shepherd.js/src/types/step';
import { AllMessengersService } from '../../pages/page-start/all-messengers.service';
import { ModalService } from '../../services/modal.service';
import { DcService } from '../../services/dc.service';
import { ToursService } from '../../services/tours.service';

@Component({
  selector: 'app-sender-shepherd',
  templateUrl: './sender-shepherd.component.html',
  styleUrls: ['./sender-shepherd.component.scss']
})
export class SenderShepherdComponent implements OnInit, AfterViewInit {
  constructor(
    private toursService: ToursService,
    private dcService: DcService,
    public modalService: ModalService,
    public allMessengersService: AllMessengersService,
    public notifierWrapService: NotifierWrapService,
    private shepherdService: ShepherdService,
    public senderService: SenderService,
    public interfaceService: InterfaceService,
  ) {
  }
  next(): void {
    if (this.shepherdService.isActive) {
      this.shepherdService.next();
    }
  }
  ngOnInit(): void {
    this.interfaceService.$onCancelAddSender.subscribe(() => {
      try {
        this.shepherdService.complete();
      }catch (e) {}
    });
    this.senderService.setSenderTypes$.pipe(
      filter(v => v >= 0 && v !== 2 && !this.senderService.tourComplete)
    ).subscribe((v) => {

      setTimeout(() => {
        this.next();
      }, 100);
    });
    this.toursService.startTour$.subscribe((timeout) => {
      this.closeModal();
      this.interfaceService.isMessageInputAnimate = true;
      this.senderService._senderAddForm = true;
      this.shepherdService.confirmCancelMessage = 'Вы точно знаете как пользоваться сервисом?';
      this.shepherdService.defaultStepOptions = defaultStepOptions;
      this.shepherdService.modal = true;
      this.shepherdService.confirmCancel = false;
      this.shepherdService.addSteps([
        this.introStep,
        this.senderButtonStep,
        this.demoSenderStep,
        this.selectTypeStep,
        this.selectTwoStep,
        this.settingsStep,
        this.textStep,
        this.sendStep
      ]);

      setTimeout(() => {
        this.senderService.openSenderChat();
        this.senderService.senderAddForm = true;
        this.shepherdService.start();
      }, timeout);
    });
  }
  closeModal() {
    if (this.modalService.bsModalRef) {
      this.modalService.bsModalRef.hide();
    }
  }
  ngAfterViewInit() {
    this.interfaceService.openChat$.pipe(
      filter((v) => this.allMessengersService.arServicesAuthorized?.length > 0
      ), first()).subscribe(() => {
      if (this.interfaceService.isTelesellerDomain && !this.tourNotShow && !this.interfaceService.isLeadsDomain) {
        // TODO disable tour this.toursService.startTour$.next(3000);
      }
    });
  }

  get buttons(): Step.StepOptionsButton[] {
    const array = [
      {
        action: () => {
          this.senderService.tourComplete = true;
          this.shepherdService.complete();
          this.shepherdService.onTourFinish('Cancel user');
          this.tourNotShow = true;
          return true;
        },
        text: 'Я уже умею',
        classes: 'btn btn-link',
      },
      {
        action: () => {
          this.senderService.tourComplete = true;
          this.shepherdService.complete();
          this.shepherdService.onTourFinish('Cancel user');
          this.tourNotShow = true;
          return true;
        },
        text: 'Позже',
        classes: 'btn btn-warning',
      },
      {
        action: () => {
          this.closeModal();
          this.senderService.openSenderChat();
          return this.next();
        },
        text: 'Далее',
        classes: 'btn btn-primary',
      }
    ];
    return array;
  }
  get introStep(): Step.StepOptions {
    return {
      id: 'sender-start',
      attachTo: {
        element: '',
        on: 'top'
      },
      buttons: this.buttons,
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Добро пожаловать в TeleSeller',
      text: ['Виртуальный помощник проведет вам обучающий тур по использованию сервиса.<br> <small>Вы легко создадите с его помощью первую рассылку.</small>'],
    };
  }
  get senderButtonStep(): Step.StepOptions {
    return {
      showOn: () => {
        return window.innerWidth > 768;
      },
      id: 'sender-start-button',
      attachTo: {
        element: 'app-sender-chat-item',
        on: 'top'
      },
      buttons: [
        ...builtInButtons
      ],
      cancelIcon: {
        enabled: true
      },
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Как вернуться к рассылкам',
      text: ['Этот пункт горит синим когда вы в интерфейсе рассылок, но при переходе на другие страницы, например при переключении на чаты ниже, блок станет серым, вы можете нажать на него что бы вернуться.'],
    };
  }
  get demoSenderStep(): Step.StepOptions {
    this.senderService.tourComplete = false;
    this.dcService.detectChanges$.next('messages-scroll');
    return {
      showOn: () => {
        return this.senderService.arHistory?.length === 0 && !this.senderService.tourComplete;
      },
      id: 'sender-demo',
      attachTo: {
        element: '#sender-demo',
        on: 'top'
      },
      buttons: [
        {
          action: () => {
            this.senderService.tourComplete = true;
            this.dcService.detectChanges$.next('messages-scroll');
            this.next();
            return true;
          },
          text: 'Далее',
          classes: 'btn btn-primary',
        }
      ],
      cancelIcon: {
        enabled: true
      },
      scrollTo: true,
      title: 'Демо рассылка',
      text: ['Так будет выглядеть созданная вами рассылка, ее содержимое зависит от выбранного типа рассылки. <small>Прогресс отображается в реальном времени (автообновление)</small>'],
    };
  }

  get selectTypeStep(): Step.StepOptions {
    return {
      showOn: () => {
        return this.senderService.tabIndex === 0;
      },
      id: 'sender-add-config',
      attachTo: {
        element: '.footer-sender-block',
        on: 'top'
      },
      buttons: [
        {
          action: () => {
            this.senderService.tourComplete = true;
            this.shepherdService.complete();
            this.shepherdService.onTourFinish('Cancel user');
            this.tourNotShow = true;
            return true;
          },
          text: 'Позже',
          classes: 'btn btn-warning',
        },
        {
          action() {
            return this.back();
          },
          classes: 'btn btn-link',
          text: 'Назад'
        }
      ],
      cancelIcon: {
        enabled: true
      },
      classes: 'custom-class-name-1 custom-class-name-2',
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Начнем добавлять расссылку',
      text: ['Выберите <b>режим</b>, определитесь какой Вам нужен<br>' +
        // Режим накрутка, например позволяет рассылать по чатам, которые заставляют подписываться при отправке сообщения
      '<small>➤ Если у вас нет списка контактов, начните с режима парсинга, инструкция есть внутри по кнопке "где взять?".<br>' +
      '➤ Если у вас уже есть список контактов, выберите "Пост/сообщение" для рассылки по ним.<br>' +
      'Вы можете посоветоваться с нами, нажав "<a target="_blank" href="https://t.me/' + this.senderService.helpChatUserName + '">Техподдержка</a>"</small>'],
    };
  }

  get selectTwoStep(): Step.StepOptions {
    return {
      id: 'sender-add-contacts',
      attachTo: {
        element: '.footer-sender-block',
        on: 'top'
      },
      buttons: [
        {
          action: () => {
            this.senderService.openHelpChatInTelegram();
          },
          classes: 'btn btn-link',
          text: 'Помощь'
        },
        {
          action: () => {
            this.senderService.tabIndex = 0;
            this.dcService.detectChanges$.next('add-form-sender');
            this.shepherdService.back();
          },
          text: 'Сменить тип',
          classes: 'btn btn-primary',
        },
        {
          action: () => {
            if (this.senderService.senderType !== 3) {
              if (this.senderService.validContacts()) {
                this.next();
                this.senderService.tabIndex = 2;
                this.dcService.detectChanges$.next('add-form-sender');
              } else {
                this.notifierWrapService.notify('error', 'Укажите список контактов');
              }
            } else {
              if (this.senderService.validChat) {
                this.next();
                if (this.senderService.showSenderSettingsTab) {
                  this.senderService.tabIndex = 2;
                  this.dcService.detectChanges$.next('add-form-sender');
                }
              } else {
                this.notifierWrapService.notify('error', this.senderService.messageErrorFillChat);
              }
            }

          },
          text: 'Далее',
          classes: 'btn btn-primary',
        }
      ],
      cancelIcon: {
        enabled: true
      },
      classes: 'custom-class-name-1 custom-class-name-2',
      highlightClass: 'highlight',
      scrollTo: false,
      title: () => {
        return this.senderService.senderType !== 3 ? 'Добавление получателей рассылки' : 'Парсинг чата и режим';
      },
      text: () => {
        return this.senderService.senderType !== 3 ? [
          'Вставьте список получателей.<br> <small> В области указаны примеры поддерживаемых типов получателей.<br>' +
          'Если у вас нет списка, на предыдущем шаге можно выбрать "Парсинг" и разослать подписчикам открытого ' +
          'канала или чата</small>'
        ] : [
          'Выберите режим парсинга, можно не только скачать файл но и сразу разослать подписчикам рассылку.<br>После чего укажите целевую группу, поддерживаются: <i>ссылки</i>, <i>username</i>, <i>id</i>. Дождитесь проверки на возможность парсинга.'
        ];
      },
    };
  }

  get settingsStep(): Step.StepOptions {
    return {
      showOn: () => {
        return this.senderService.showSenderSettingsTab;
      },
      id: 'sender-add-text',
      attachTo: {
        element: '.footer-sender-block',
        on: 'top'
      },
      buttons: [
        {
          action: () => {
            this.senderService.openHelpChatInTelegram();
          },
          classes: 'btn btn-link',
          text: 'Помощь'
        },
        {
          action: () => {
            if (this.senderService.validLoop()) {
              this.next();
            } else {
              this.notifierWrapService.notify('error', this.senderService.messageErrorFillLoop);
            }
          },
          text: 'Далее',
          classes: 'btn btn-primary',
        }
      ],
      cancelIcon: {
        enabled: true
      },
      classes: 'custom-class-name-1 custom-class-name-2',
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Настройки рассылки',
      text: ['Тут вы можете указать настройки для рассылки. '],
    };
  }

  get textStep(): Step.StepOptions {
    return {
      showOn: () => {
        return !this.senderService.disabledMessageTextarea;
      },
      id: 'sender-add-settngs',
      attachTo: {
        element: '#message-form',
        on: 'top'
      },
      buttons: [
        {
          action() {
            return this.back();
          },
          classes: 'btn btn-link',
          text: 'Назад'
        },
        {
          action: () => {
            this.senderService.openHelpChatInTelegram();
          },
          classes: 'btn btn-link',
          text: 'Помощь'
        },
        {
          action: () => {
            if (this.senderService.message?.length > 0) {
              this.next();
            } else {
              this.notifierWrapService.notify('error', 'Введите текст рассылки');
            }
          },
          text: 'Далее',
          classes: 'btn btn-primary',
        }
      ],
      cancelIcon: {
        enabled: true
      },
      classes: 'custom-class-name-1 custom-class-name-2',
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Напишите текст рассылки',
      text: ['Вы можете использовать функциии редактора над полем ввода и выбрать смайлы, для украшения и выделения текста.<br><small>Так же правее есть кнопка прикрепления фото к сообщению или любого другого файла.</small>'],
    };
  }

  get sendStep(): Step.StepOptions {
    return {
      showOn: () => {
        return true;
      },
      id: 'sender-add-settngs',
      attachTo: {
        element: '.chat-footer [type="submit"]',
        on: 'top'
      },
      buttons: [
        {
          action() {
            return this.back();
          },
          classes: 'btn btn-link',
          text: 'Назад'
        },
        {
          action: () => {
            this.senderService.openHelpChatInTelegram();
          },
          classes: 'btn btn-link',
          text: 'Помощь'
        },
        /*{
          action: () => {
            this.next();
            // this.senderService.
          },
          text: 'Все понятно :)',
          classes: 'btn btn-primary',
        }*/
      ],
      cancelIcon: {
        enabled: true
      },
      classes: 'custom-class-name-1 custom-class-name-2',
      highlightClass: 'highlight',
      scrollTo: false,
      title: 'Завершение',
      text: [
        '<b>Поздравляем!</b> Теперь вам остается только нажать кнопку отправки.<br>' +
        '<small>Рассылка появится в истории ваших рассылок и вы сможете смотреть статистику и управлять ей.</small>'
      ],
    };
  }

  get tourNotShow(): boolean {
    return !!localStorage.getItem('tour_not_complete');
  }
  set tourNotShow(val) {
    localStorage.setItem('tour_not_complete', new Date().getTime().toString());
  }
}
